<template>
  <svg
    id="Arrow-Up--Streamline-Solar-Ar"
    viewBox="-1 -1 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height="48"
    width="48"
  >
    <desc>Arrow Up Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="m23 38.333333333333336 0 -30.666666666666668m0 0 11.5 11.5m-11.5 -11.5 -11.5 11.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke-width="strokeWidth"
    ></path>
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    strokeWidth?: number
  }>(),
  {
    strokeWidth: 2,
  }
)
</script>
